import {useTranslation} from 'react-i18next'

export default function TableCca(){
  const {t} = useTranslation();
  const prefix = 'optimizers.company.ti.products.5.details.table.'

  const trs = [];
  for(let i = 0; i < 8; i+=2){
    trs.push((
      <tr key={i} className='border border-t-gray-200'>
        <td className='lg:w-[210px] px-4 py-4 text-gray-600 bg-gray-100 text-xs lg:text-sm'>{t(`${prefix}${i+4}`)}</td>
        <td className='lg:w-[340px] px-4 py-4 text-gray-600 text-sm border border-t-gray200 border-r-transparent'>{t(`${prefix}${i+5}`)}</td>
      </tr>
    ));
  }
  return (
    <table>
      <tbody>
        <tr className='border border-t-hover'>
          <th rowSpan={5} className='lg:w-[170px] bg-[#EDEDED] text-gray-600 text-light'>{t(`${prefix}1`)}</th>
          <td className='lg:w-[210px] px-4 py-4 text-gray-600 bg-gray-100 text-xs lg:text-sm'>{t(`${prefix}2`)}</td>
          <td className='lg:w-[340px] px-4 py-4 text-gray-600 text-xs lg:text-sm border border-t-hover border-r-transparent'>{t(`${prefix}3`)}</td>
        </tr>
        {
          trs
        }
      </tbody>
    </table>
  );
}